module.exports = __webpack_public_path__ + "static/media/logo_animation.eb4d34e3.gif";